import { render, staticRenderFns } from "./TaskTab.vue?vue&type=template&id=374b39b4&"
import script from "./TaskTab.vue?vue&type=script&lang=js&"
export * from "./TaskTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports